import { motion } from 'framer-motion'

import { ContactModal } from '@apps-common/apps/portal/pages/management/components/contact'
import { ButtonRoundedWithIcon } from '@apps-common/components/elements'
import { VertSpacerLg, VertSpacerMd } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { GRID_CARD_VARIANTS } from '@apps-common/config/motion-variants'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IContactListModel } from '@apps-common/types/management/contact'

interface IProps {
  contact: IContactListModel
}
export const ContactListCard = ({ contact }: IProps) => {
  const { contactId, name, email, companyName } = contact

  return (
    <motion.div
      variants={GRID_CARD_VARIANTS}
      className='w-full overflow-hidden p-6 rounded-[35px] bg-surface text-text border border-border'
    >
      <div className='flex items-center justify-between w-full'>
        <div className='jost'>{name}</div>
      </div>
      <div className='flex flex-col gap-[5px] text-[0.9em]'>
        <VertSpacerMd />
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light bg-surface-2 leading-[1em] p-1 rounded'>Company:</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{companyName}</p>
        </div>
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] text-[0.9em]'>
          <p className='jost-light bg-surface-2 leading-[1em] p-1 rounded'>Email:</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{email}</p>
        </div>
      </div>
      <VertSpacerLg />
      <ModalButton
        classes='w-full flex justify-end'
        component={ContactModal}
        disabled={false}
        componentProps={{
          contactId
        }}
        enterAnimation={modalSlideUpEnterAnimation}
        leaveAnimation={modalSlideUpLeaveAnimation}
      >
        <ButtonRoundedWithIcon
          type='div'
          text='Details'
          icon={<commonIcons.arrowAngled />}
          className='action-brand !w-auto !grow-0'
          iconContainerClassName='bg-brand text-on-brand'
        />
      </ModalButton>
    </motion.div>
  )
}
